import { Card } from "antd";
import customStyles from "../../../../assets/styles/customStyles";
import clsx from 'clsx';

const PrimaryCard = props => {
    const { title, component, customClass, width, height } = props

    const classes = customStyles();
    return (
        <>
            <Card
                title={title}
                style={{ height: height ? height : 'calc(100dvh - 160px)', minHeight: "350px", width: width ? width : 'auto' }}
                className={clsx(customClass, classes.tableRoot)}>
                {component}
            </Card>
        </>
    )
}

export default PrimaryCard